import { Box, FlexLayout, H3 } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import type { IValidationMessage } from '@deity-io/di-data-flows-editor';
import { H4, Icon } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface ValidationErrorListProps {
  messages: Array<IValidationMessage>;
  fields?: {
    type?: boolean;
    path?: boolean;
    flow?: boolean;
    component?: boolean;
    port?: boolean;
    message?: boolean;
  };
  onClick?: (componentId: string) => void;
}

const ValidationErrorList: FC<ValidationErrorListProps> = ({ messages, fields, onClick }) => {
  let count = 0;
  const displayFields = {
    ...{
      type: true,
      messages: true
    },
    ...(fields || {})
  };
  const controlMessages: Record<string, Array<IValidationMessage>> = {};
  const flowMessages: Array<IValidationMessage> = [];
  messages.forEach(message => {
    if (message.component) {
      if (message.component in controlMessages) {
        controlMessages[message.component].push(message);
      } else {
        controlMessages[message.component] = [message];
      }
    } else {
      flowMessages.push(message);
    }
  });

  return (
    <FlexLayout key="ValidationErrorListFlex">
      {messages.length > 0 && <H4 style={{ paddingTop: '20px' }}>Messages</H4>}
      <Box key="ValidationErrorListBOX" p="lg" width="full">
        {mapRecordToArray(controlMessages, (messageList, controlKey) => (
          <FlexLayout flexDirection="column" key={controlKey}>
            {displayFields.component && <H3 style={{ paddingTop: '10px' }}>{controlKey}</H3>}
            {messageList.map(message => {
              // eslint-disable-next-line no-plusplus
              count++;

              return (
                <FlexLayout
                  flexDirection="row"
                  flexWrap="nowrap"
                  key={`div_${count}`}
                  onClick={onClick ? () => onClick(controlKey) : undefined}
                  css={
                    onClick
                      ? {
                          cursor: 'pointer'
                        }
                      : {}
                  }
                >
                  <Icon
                    key={`icon_${count}`}
                    icon={message.type === 'error' ? 'error' : 'warning'}
                    color={message.type === 'error' ? 'error' : 'warning'}
                  />
                  {message.message}
                </FlexLayout>
              );
            })}
          </FlexLayout>
        ))}
        <FlexLayout flexDirection="column" key="flow">
          {displayFields.component && <H3 style={{ paddingTop: '10px' }}>Flow</H3>}
          {flowMessages.map(message => {
            // eslint-disable-next-line no-plusplus
            count++;

            return (
              <FlexLayout flexDirection="row" flexWrap="nowrap" key={`div_${count}`}>
                <Icon
                  key={`icon_${count}`}
                  icon={message.type === 'error' ? 'error' : 'warning'}
                  color={message.type === 'error' ? 'error' : 'warning'}
                />
                {message.message}
              </FlexLayout>
            );
          })}
          <br />
        </FlexLayout>
      </Box>
    </FlexLayout>
  );
};

export default ValidationErrorList;
